export default "__VITE_ASSET__Dpmho6ru__"